import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {Card,CardContent,} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { checkForUpdates, getApiCadVer, getApiVer } from '../reducers/AppInfoReducer';
import Button from '@material-ui/core/Button';
import brandIcon from 'assets/images/brand-icon.png';
import ptsLogo from 'assets/images/PTS-logo.png';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    minHeight: 150,
  },
  card: {
    width: 480,
    background: 'fff',
    '& img': {
      width: '100%',
    },
  },
  
    branding: {
    width: '100%',
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#000',
    '& img': {
      width: 150,
      height: 'auto',
    },
  },
  branding2: {
    width: '100%',
    textAlign: 'center',
    padding: '45px 0 5px',
    '& img': {
      height: 50,
      width: 'auto',
    },
  },
  actions: {
    textAlign: 'center',
    marginTop: 30,
    '& button': {
      background: '#000',
      paddingLeft: '4em',
      paddingRight: '4em',
      textTransform: 'uppercase',
      color: '#fff',
      '&:hover': {
        background: '#555',
      },
    },
  },
  footer: {
    fontSize: 13,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'end',
    '& p': {
      marginBottom: 0,
    },
  },
  action: {
    marginBottom: 10,
  },
}));

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

function AboutDialog(props) {
  const classes = useStyles();
  const { apiVersion, availBuildNo, availBuildTime, buildNo, buildTime, appVersion } = props.appInfo;
  const updateAvail = buildNo !== availBuildNo || buildTime !== availBuildTime;

  useEffect(() => {
    props.getApiVer();
    props.getApiCadVer();
    props.checkForUpdates();
    // eslint-disable-next-line
  }, []);

  const reload = () => {
    window.location.reload(true);
  };

  return (
    <Dialog onClose={props.close} open={true}>
      <DialogContent dividers className='p-0'>
      <Card className={classes.card}>
        <div className={classes.branding}>
          <img src={brandIcon} alt="MOBILE icon" />
        </div>
        <div className={classes.branding2}>
          <img src={ptsLogo} alt="PTS logo" />
        </div>
        <CardContent>
        <div className={classes.content}>          
          <div className={classes.body}>
            <p>
              App version: {appVersion} <br /> Api version: {apiVersion} <br /> Build no: {buildNo}{' '}
              <br /> Build date: {buildTime} <br />
              {updateAvail && <span>(update available)</span>}
              {!updateAvail && <span>(up to date)</span>}
            </p>
            {updateAvail && (
              <div className={classes.action}>
                <Button size="small" variant="outlined" className={classes.margin} onClick={reload}>
                  Reload
                </Button>
              </div>
            )}

            <div className={classes.actions}>
              <Button  variant="contained" size="large" className="my-2" onClick={props.close}>
                Close
              </Button>
            </div>
          </div>
          <div className={classes.footer}>
            <p>
              &copy; 2020 <a style={{ color: '#2871cc' }} href="https://ptssolutions.com">ptssolutions.com</a>, All Rights
              Reserved
            </p>
          </div>
        </div>          
        </CardContent>
      </Card>     
      </DialogContent>
    </Dialog>
  );
}

const mapStateToProps = state => {
  return {
    appInfo: state.appInfo,
  };
};

export default connect(mapStateToProps, { 
  checkForUpdates, getApiCadVer, getApiVer
})(AboutDialog);
